import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import mainMixin from './mainMixin.js'
import VueTruncate from 'vue-truncate-filter'
import VueSanitize from 'vue-sanitize'

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
Vue.component('PerfectScrollbar', PerfectScrollbar)

var defaultOptions = {
  allowedTags: ['a', 'br'],
  allowedAttributes: {
    a: ['href']
  }
}
Vue.use(VueSanitize, defaultOptions)
Vue.use(VueTruncate)
Vue.config.productionTip = false

Vue.mixin(mainMixin)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
